module.exports = __webpack_public_path__ + "media/images/consumer/signup/payment/credit-card/american_express-cdadf7f86fced1dbacb9c235e7f8b332.png";